import request from '@/utils/axios'

// 我的资产-总资产
export function ajax_getMyAssetsInfo(data) {
  return request({
    method: 'post',
    url: '/asset/getAllAsset',
    data,
  })
}
// 我的资产-币币资产
export function ajax_getMyTokenAsset(data) {
  return request({
    method: 'post',
    url: '/asset/getConversionAsset',
    data,
  })
}

// 我的资产-资产列表
export function ajax_getMyAssetList(data) {
  return request({
    method: 'post',
    url: '/asset/accountList',
    data,
  })
}

// 获取可提币充币的币种
export function fetchAllCoins() {
  return request({
    method: 'post',
    url: '/asset/allCoins',
  })
}

// 获取充币地址
export function ajax_getRechargeAddress(data) {
  return request({
    method: 'post',
    url: '/asset/getUserChainAddress',
    data,
  })
}

// 充币记录
export function ajax_getRechargeLog(data) {
  return request({
    method: 'post',
    url: '/asset/recordsCoinInList',
    data: {
      offset: 7,
      ...data,
    },
  })
}

// 账单（充币和提币记录）
export function ajax_getBill(data) {
  return request({
    method: 'post',
    url: '/member/assets/wallet/transaction/page',
    data,
  })
}

// 提币记录
export function getWithdrawRecordAPI(data) {
  return request({
    method: 'post',
    url: '/asset/recordsCoinOutList',
    data,
  })
}

// 用户权限认证情况
export function ajax_getAuthorizationStatus() {
  return request({
    method: 'post',
    url: '/userCenter/getAuthInfo',
  })
}

// 添加提币的地址
export function ajax_addWithdrawalAddress(data) {
  return request({
    method: 'post',
    url: '/member/assets/wallet/memberAddress/memberAddress',
    data,
  })
}

// 获取提币的地址
export function ajax_getMentionMoneyAddress(data) {
  return request({
    method: 'get',
    url: '/member/assets/wallet/memberAddress/getAddressByCoin',
    params: data,
  })
}

// 根据 id 删除地址
export function ajax_delAddressById(id) {
  return request({
    method: 'delete',
    url: '/member/assets/wallet/memberAddress/' + id,
  })
}

// 获取最小可提币数量和手续费
export function ajax_getMinNumAndServiceCharge(data) {
  return request({
    method: 'get',
    url: '/member/assets/wallet/coin/enableWithdraw',
    params: data,
  })
}

// 提币接口
export function ajaxPost_MentionMoney(data) {
  return request({
    method: 'post',
    url: '/userCenter/coinOut',
    data,
  })
}

// 获取财务记录
export function financeHistory(data) {
  return request({
    url: '/member/assets/wallet/transaction/page',
    method: 'post',
    data: data,
  })
}

// 获取新高增奖励
export function increaseReward(data) {
  return request({
    url: '/member/member/incremental/commissionIncome-page',
    method: 'post',
    data: data,
  })
}

// 获取交易手续费奖励
export function poundageReward(data) {
  return request({
    url: '/member/member/transactionFee/info',
    method: 'post',
    data: data,
  })
}

// 获取活动奖励、活动锁仓/延迟奖金
export function activitylockDelay(data) {
  return request({
    url: '/member/member/activity/flow/commissionIncome-page',
    method: 'post',
    data: data,
  })
}

// 撤销提币
export function ajaxGet_cancelMentionMoney(id) {
  return request({
    method: 'get',
    url: '/member/assets/wallet/withdrawRecord/cancel',
    params: { id },
  })
}

// 获取链列表
// export function ajaxGet_chainList(data) {
//   return request({
//     method: 'get',
//     url: '/member/assets/wallet/coin/enableWithdraw',
//     params: data
//   })
// }

// 根据币种名称获取币种信息
export function fetchCoinInfoByCoinName(data) {
  return request({
    method: 'post',
    url: '/information/coinInfo',
    data,
  })
}

// 根据币种ID获取币种可用数量
export function fetchAmountUsableyCoinId(data) {
  return request({
    method: 'post',
    url: '/asset/accountAmountUsable',
    data,
  })
}

// 获取用户合约资产
export function fetchUserContractAsset() {
  return request({
    url: '/asset/contractBalance',
    method: 'post',
  })
}

// 获取合约划转记录
export function fetchUserContractTrasferRecord(data) {
  return request({
    url: '/asset/contractTransferFlow',
    method: 'post',
    data,
  })
}
